var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchivesDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 505 505",
    style: {
      enableBackground: "new 0 0 505 505"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#90DFAA"
    },
    cx: 252.5,
    cy: 252.5,
    r: 252.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M166.6,381H77.8c-1.3,0-2.4-1.1-2.4-2.4V139.4c0-1.3,1.1-2.4,2.4-2.4h88.9c1.3,0,2.4,1.1,2.4,2.4 v239.2C169.1,379.9,168,381,166.6,381z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.1,
    y: 152.7,
    style: {
      fill: "#FFFFFF"
    },
    width: 62.2,
    height: 149.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 167.9,
    style: {
      fill: "#E6E9EE"
    },
    width: 42.4,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 194.7,
    style: {
      fill: "#E6E9EE"
    },
    width: 42.4,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 221.6,
    style: {
      fill: "#E6E9EE"
    },
    width: 42.4,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 248.4,
    style: {
      fill: "#E6E9EE"
    },
    width: 42.4,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 275.2,
    style: {
      fill: "#E6E9EE"
    },
    width: 42.4,
    height: 11.9
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 122.2,
    cy: 342.4,
    r: 19
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C9984"
    },
    d: "M275,381h-88.9c-1.3,0-2.4-1.1-2.4-2.4V139.4c0-1.3,1.1-2.4,2.4-2.4H275c1.3,0,2.4,1.1,2.4,2.4v239.2 C277.5,379.9,276.4,381,275,381z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.5,
    y: 152.7,
    style: {
      fill: "#FFFFFF"
    },
    width: 62.2,
    height: 149.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 209.4,
    y: 167.9,
    style: {
      fill: "#E6E9EE"
    },
    width: 42.4,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.4,
    y: 194.7,
    style: {
      fill: "#E6E9EE"
    },
    width: 42.4,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.4,
    y: 221.6,
    style: {
      fill: "#E6E9EE"
    },
    width: 42.4,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.4,
    y: 248.4,
    style: {
      fill: "#E6E9EE"
    },
    width: 42.4,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.4,
    y: 275.2,
    style: {
      fill: "#E6E9EE"
    },
    width: 42.4,
    height: 11.9
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 230.6,
    cy: 342.4,
    r: 19
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M427.3,364.4l-87.4,16.1c-1.3,0.2-2.6-0.6-2.8-1.9l-43.4-235.2c-0.2-1.3,0.6-2.6,1.9-2.8l87.4-16.1 c1.3-0.2,2.6,0.6,2.8,1.9l43.4,235.2C429.4,362.9,428.6,364.2,427.3,364.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.951,
    y: 190.458,
    transform: "matrix(-0.1813 -0.9834 0.9834 -0.1813 202.3034 611.5302)",
    style: {
      fill: "#FFFFFF"
    },
    width: 149.496,
    height: 62.198
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 324.788,
    y: 162.786,
    transform: "matrix(-0.9834 0.1813 -0.1813 -0.9834 716.8331 271.9469)",
    style: {
      fill: "#E6E9EE"
    },
    width: 42.399,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.693,
    y: 189.18,
    transform: "matrix(-0.9834 0.1813 -0.1813 -0.9834 731.347 323.407)",
    style: {
      fill: "#E6E9EE"
    },
    width: 42.399,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.495,
    y: 215.592,
    transform: "matrix(-0.9834 0.1813 -0.1813 -0.9834 745.6614 374.9236)",
    style: {
      fill: "#E6E9EE"
    },
    width: 42.399,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.398,
    y: 241.985,
    transform: "matrix(-0.9834 0.1813 -0.1813 -0.9834 760.1712 426.382)",
    style: {
      fill: "#E6E9EE"
    },
    width: 42.399,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.299,
    y: 268.378,
    transform: "matrix(-0.9834 0.1813 -0.1813 -0.9834 774.6771 477.8427)",
    style: {
      fill: "#E6E9EE"
    },
    width: 42.399,
    height: 11.9
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 376.6,
    cy: 334.5,
    r: 19
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivesDocument);
export default __webpack_public_path__ + "static/media/archives-document.db8e7a68cbcd9b3207067b502ff617ba.svg";
export { ForwardRef as ReactComponent };